<template>
  <div class="modal-mask" @click.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__close" @click.stop="closeModal">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L12 12" stroke="currentColor" stroke-width="2"/>
          <path d="M1 12L12 1" stroke="currentColor" stroke-width="2"/>
        </svg>
      </div>
      <img :src="image.url" alt="">
      <div class="controls">
        <div class="prev"
             :class="prevActive ? '' : 'disabled'"
             @click.stop="prevImage(image.image_id)">
          <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.0234 8.96802L1.99995 9.04702M1.99995 9.04702L7.22596 3.97317M1.99995 9.04702L7.35568 14.5634" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <div class="next"
             :class="nextActive ? '' : 'disabled'"
             @click.stop="nextImage(image.image_id)">
          <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.97656 9.04712L16.0001 8.96812M16.0001 8.96812L10.774 14.042M16.0001 8.96812L10.6443 3.45177" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app-image-modal',
  components: {},
  props: {
    image: Object,
    prevActive: Boolean,
    nextActive: Boolean
  },
  data () {
    return {}
  },
  methods: {
    prevImage (currentId) {
      this.$emit('prev-image', currentId)
    },
    nextImage (currentId) {
      this.$emit('next-image', currentId)
    },
    closeModal () {
      this.$emit('close-modal')
    }
  },
  beforeUpdate () {
    this.$emit('updated', this.image.image_id)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal {
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: auto;
  max-width: 720px;
  padding: 4px;
  border: 1px solid $border_color;
  border-radius: 3px;
  background: $color_main;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.25);

  &__close {
    position: absolute;
    right: -18px;
    top: -22px;
    color: $font_color_alt;
    cursor: pointer;
    transition: .3s;

    &:hover {
      color: $font_color_third;
    }
  }

  img {
    max-height: 80vh;
  }
}

.controls {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
}

.prev,
.next {
  width: 22px;
  height: 22px;
  cursor: pointer;
  color: $font_color_main;

  svg {
    width: 100%;
    height: 100%;
    transition: .3s;
  }

  &:hover svg {
    color: $color_second-light;
  }

  &.disabled {
    pointer-events: none;
    color: $color_deactive;
  }
}

</style>
